<template>
    <div>
        <!-- services -->
        <section class="banner-bottom-w3layouts bg-li py-5" id="services">
            <div class="container py-xl-5 py-lg-3 container1500">
                <h3 class="tittle text-center font-weight-bold">
                    {{ $t("index.sixth.title") }}
                </h3>
                <p class="sub-tittle text-center mt-3 mb-sm-5 mb-4">
                    {{ $t("index.sixth.subTitle") }}
                </p>
                <div class="row pt-lg-4">
                    <div class="col-lg-4 about-in text-center">
                        <a @click="toPage('/Updated-Journal-Lists')">
                            <div class="card">
                                <div class="card-body">
                                    <div class="bg-clr-w3l">
                                        <span class="fa fa-refresh"></span>
                                    </div>
                                    <h5 class="card-title mt-4 mb-3">
                                        {{ $t("index.sixth.content1li1") }}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-4 about-in text-center my-lg-0 my-3">
                        <a @click="toPage('/Dynamic-Journal-Impact-Factor')">
                            <div class="card active">
                                <div class="card-body">
                                    <div class="bg-clr-w3l">
                                        <span class="fa fa-stumbleupon"></span>
                                    </div>
                                    <h5 class="card-title mt-4 mb-3">
                                        {{ $t("index.sixth.content1li2") }}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-lg-4 about-in text-center">
                        <a href="javascript:void(0);">
                            <div class="card">
                                <div class="card-body">
                                    <div class="bg-clr-w3l">
                                        <span class="fa fa-leanpub"></span>
                                    </div>
                                    <h5 class="card-title mt-4 mb-3" style="font-size: 20px">
                                        {{ $t("index.sixth.content1li3") }}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <!-- //services -->

        <!-- stats -->

        <!-- //stats -->

        <!-- partners -->
        <section class="partners py-5" id="partners">
            <div class="container py-xl-5 py-lg-3 container1500">
                <h3 class="tittle text-center font-weight-bold" style="margin-bottom: 40px">
                    {{ $t("index.sixth.title2") }}
                </h3>
                <!-- <p class="sub-tittle text-center mt-3 mb-sm-5 mb-4">Springer Nature | EIsevier | Taylor&amp;Francis |
					WILEY
					| SAGE | World Scientific | IEEE | ASME | Cambridge</p> -->
                <!-- <h6>◈ Publishers</h6> -->
                <div class="row grid-part text-center pt-4">
                    <div v-for="(publisher, index) in publishers.slice(0, 6)" :key="index" class="col-md-2 col-4"
                        :class="{ 'mt-md-0 mt-4': index >= 3 }">
                        <div class="parts-w3ls">
                            <a :href="publisher.url" target="_blank">
                                <img :src="publisher.img" :alt="publisher.name">
                            </a>
                            <h4>{{ publisher.name }}</h4>
                        </div>
                    </div>
                </div>
                <div class="row grid-part text-center pt-4">
                    <div v-for="(publisher, index) in publishers.slice(6)" :key="index + 6" class="col-md-2 col-4"
                        :class="{ 'mt-md-0 mt-4': index >= 3 }">
                        <div class="parts-w3ls">
                            <a :href="publisher.url" target="_blank">
                                <img :src="publisher.img" :alt="publisher.name" width="133px"> 
                            </a>
                            <h4>{{ publisher.name }}</h4>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            publishers: [
                {
                    name: "OpenCitations",
                    url: "http://opencitations.net/",
                    img: require('@/assets/images/Publishers/OC.png'),
                },
                {
                    name: "Software Heritage",
                    url: "https://www.softwareheritage.org/",
                    img: require('@/assets/images/Publishers/sh.png'),
                },
                {
                    name: "PKP",
                    url: "https://pkp.sfu.ca/",
                    img: require('@/assets/images/Publishers/OJS.png'),
                },
                {
                    name: "DOAJ",
                    url: "https://doaj.org/",
                    img:require('@/assets/images/Publishers/DOAJ.png'),
                },
                {
                    name: "DOAB",
                    url: "https://doabooks.org/",
                    img: require('@/assets/images/Publishers/doab.png'),
                },
                {
                    name: "Arxiv",
                    url: "https://arxiv.org/",
                    img: require('@/assets/images/Publishers/arxiv.png'),
                },
                {
                    name: "Dryad",
                    url: "https://datadryad.org/stash",
                    img: require('@/assets/images/Publishers/dryad.png'),
                },
                {
                    name: "CrossRef",
                    url: "https://www.crossref.org/",
                    img: require('@/assets/images/Publishers/CrossRef.png'),
                },
                {
                    name: "Altmetric",
                    url: "https://www.altmetric.com/",
                    img: require('@/assets/images/Publishers/Altmetric.png'),
                },
                {
                    name: "Digital Science",
                    url: "https://www.digital-science.com/",
                    img: require('@/assets/images/Publishers/Digital-Science.png'),
                },
                {
                    name: "DSpace",
                    url: "https://dspace.lyrasis.org/",
                    img: require('@/assets/images/Publishers/DSPACE.png'),
                },
                {
                    name: "Contrimetric",
                    url: "https://contrimetric.com/",
                    img: require('@/assets/images/Publishers/Contrimetric_logo.png'),
                },
            ],
        };
    },
    methods: {
        toPage(url) {
            this.$router.push({
                path: url,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.card:hover{
    cursor: pointer;
}</style>
